import { Pipe, PipeTransform } from '@angular/core';
import { translateIdCombinedIdTagType, translateIdTagStatus } from '../mappers/enum-translation-mapper';

@Pipe({
  name: 'translatedTagCombinedTypeEnu',
})
export class TranslateIdTagCombinedTypeEnumPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined) {
      return '';
    }
    return translateIdCombinedIdTagType(value);
  }
}
